import type { ReactNode } from 'react'
import { Outlet } from 'react-router-dom'
import Loading from '@features/shared/components/Loading'
import NotFoundPage from '@/app/pages/NotFoundPage'
import { useSettingsStore } from '@features/settings/stores/useSettingsStore'
import { getModuleAccess } from '../logic/moduleAccess'

interface RequireModuleProps {
  /** Slug of the product module from the seeded catalog, e.g. `automations`. */
  moduleSlug: string
  /** Rendered instead of Not Found when the module is disabled. */
  fallback?: ReactNode
}

/**
 * Route guard for a licensable product module. A disabled or unknown module is
 * Not Found, matching the backend's 404; loading shows while the catalog is unknown.
 */
export default function RequireModule({ moduleSlug, fallback }: RequireModuleProps) {
  const modules = useSettingsStore((state) => state.modules)

  if (modules === null) return <Loading />
  if (!getModuleAccess(modules, moduleSlug).available) return fallback ?? <NotFoundPage />

  return <Outlet />
}
